import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=65381a58&scoped=true&"
import script from "./Item.vue?vue&type=script&lang=js&"
export * from "./Item.vue?vue&type=script&lang=js&"
import style0 from "./Item.vue?vue&type=style&index=0&id=65381a58&prod&lang=scss&"
import style1 from "./Item.vue?vue&type=style&index=1&id=65381a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65381a58",
  null
  
)

export default component.exports